import { z } from "zod";
import { CERTIFICATION_KINDS } from "./types.js";
import type { CertificationKind } from "./types.js";

const optionalDate = z
  .string()
  .trim()
  .transform((v) => (v === "" ? null : v))
  .refine((v) => v == null || /^\d{4}-\d{2}-\d{2}$/.test(v), "Date attendue au format AAAA-MM-JJ")
  .nullish()
  .transform((v) => v ?? null);

const optionalText = (max: number, message: string) =>
  z
    .string()
    .trim()
    .max(max, message)
    .transform((v) => (v === "" ? null : v))
    .nullish()
    .transform((v) => v ?? null);

export const listCertificationsInput = z.object({
  confirmationId: z.string().optional(),
  employeeId: z.string().uuid().optional(),
});

export const saveCertificationInput = z
  .object({
    confirmationId: z.string().optional(),
    /** Absent à la création. */
    id: z.string().uuid().optional(),
    employeeId: z.string().uuid("Salarié attendu"),
    kind: z.enum(CERTIFICATION_KINDS as [CertificationKind, ...CertificationKind[]]),
    label: optionalText(120, "Précision trop longue"),
    obtainedOn: optionalDate,
    expiresOn: optionalDate,
    renewalPlannedOn: optionalDate,
    notes: optionalText(1000, "Notes trop longues"),
  })
  .refine((v) => !v.obtainedOn || !v.expiresOn || v.expiresOn >= v.obtainedOn, {
    message: "La date d'expiration précède la date d'obtention",
    path: ["expiresOn"],
  });

export const removeCertificationInput = z.object({
  confirmationId: z.string().optional(),
  id: z.string().uuid("Identifiant de papier attendu"),
});

export type ListCertificationsInput = z.infer<typeof listCertificationsInput>;
export type SaveCertificationInput = z.infer<typeof saveCertificationInput>;
export type SaveCertificationFormInput = z.input<typeof saveCertificationInput>;
export type RemoveCertificationInput = z.infer<typeof removeCertificationInput>;
